module.exports = __webpack_public_path__ + "static/media/mysql.b04e488e.svg";